import DefaultSavedArticles, {
  StandaloneSavedArticles,
  StandaloneSavedArticlesProps,
} from '@/components/content/SavedArticles';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export const ElleStandaloneSavedArticles: StandaloneComponent<StandaloneSavedArticlesProps> = (props) => {
  return (
    <StandaloneSavedArticles
      {...mergeProps(
        {
          icon: { name: 'bin' },
        },
        props
      )}
    />
  );
};

export const standalone = ElleStandaloneSavedArticles;

export default DefaultSavedArticles;
